import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";

class RoomUserVideoTrackFilterApi extends BaseApi {
    constructor() {
        super();
        Room.User.FaceDetector = this;
        Room.addEventListeners(this._CoreEvents, this);
        Room.ready(async e => {
            this._eventListen(this._Events);
        }, {order: 100});
    }

    async filter () {
        let stream = await Room.Call.Stream.getCurrentLocalStream(true);
        if(!stream) return;
        let track = stream.getVideoTracks()[0];
        let trackApp = track?._grm_tg;
        if(!trackApp) return;

        // const personalSetting = await Room.CamStudy.getPersonalSetting();
        // let blurVideo = personalSetting?.blurVideo;
        // if(blurVideo.percent && blurVideo.blurSize){}
        const blurVideo = await this.getBlurOptions();
        trackApp.setPipeOptions('BlurFilter', {...blurVideo});
    }

    async changeBlurOptions(data) {
        await this.saveBlurOptions(data)
        await this.filter();
    }

    async getBlurOptions() {
        let localStorageVideoSetting = localStorage.getItem('grm_cams_personal_video_setting');
        localStorageVideoSetting = localStorageVideoSetting ? JSON.parse(localStorageVideoSetting) : {};
        let blurVideo = localStorageVideoSetting?.blurVideo;
        if(!blurVideo) {
            if(Room.isEntered()){
                blurVideo = {
                    use: false,
                    percent: 0,
                    blurSize: parseInt(15/2)
                };
            }else{
                const personalSetting = await Room.CamstudyPersonal.getPersonalSetting();
                blurVideo = personalSetting?.blurVideo;
            }
        }
        return blurVideo;
    }

    async saveBlurOptions(data) {
        const blurVideo = await (async () => {
            if(!Room.isEntered()){
                return {...data};
            }
            const currentSetting = Room.getRoomData().roomCamStudy.personalSetting || {};
            const blurVideo = { ...currentSetting.blurVideo, ...data };

            await Room.addRoomData({
                roomCamStudy: {
                    personalSetting: {
                        ...currentSetting,
                        blurVideo: blurVideo
                    }
                }
            });
            return blurVideo;
        })();

        if(blurVideo.use === undefined || blurVideo.use === null){
            blurVideo.use = blurVideo.percent > 0 && blurVideo.blurSize > 0;
        }

        let localStorageVideoSetting = await this.getBlurOptions();
        localStorageVideoSetting = {
            ...localStorageVideoSetting,
            blurVideo
        };
        localStorage.setItem('grm_cams_personal_video_setting', JSON.stringify(localStorageVideoSetting))

        this.filter();
    }

    _CoreEvents = {
        room_call_loadLocalStream: async function(e) {
            this.filter();
        },
        // room_changePersonalSetting: async function(e) {
        //     this.filter();
        // }
    }
    _Events = {

    }
}

export const RoomUserVideoTrackFilter = new RoomUserVideoTrackFilterApi();
